import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './components/App';
import shouldPolyfill from './polyfills/should';

function getAppProps() {
    return {
        ...(window.props || null),
        environment: process.env.ENV,
        apiUrl: process.env.API_URL,
    };
}

function renderApp(props) {
    const element = document.getElementById('app');
    const app = React.createElement(App, props);
    const strictMode = React.createElement(React.StrictMode, {}, app);
    const root = createRoot(element);
    root.render(strictMode);
}

if (shouldPolyfill()) {
    import('./polyfills/index').then(() => renderApp(getAppProps()));
} else {
    renderApp(getAppProps());
}
